/**
 * InspectionsPage
 *
 * Page wrapper for the InspectionRounds component.
 * Provides PageLayout and passes through standard page props.
 */

import { PageLayout } from '@/components/layout'
import { InspectionRounds } from '@/components/production/forecasting'

export default function InspectionsPage({ user, onLogout }) {
  return (
    <PageLayout user={user} onLogout={onLogout}>
      <InspectionRounds />
    </PageLayout>
  )
}
